import React from 'react'; 

const Button = (props) =>{
    return(
    <button onClick={props.onClick} style={{height:'50px', width:"90%", marginTop:'10px', marginBottom:'10px'}}>{props.children}</button>)
}

export default Button; 
